import React from 'react'
import { FormControl, Select, MenuItem, InputLabel } from '@mui/material'
const SelectInvoiceOption = ({
  invoiceOption,
  onChange,
  validationErrors,
  label = true,
  isSelected,
  isCloning = false,
  isDisabled = false,
}) => {
  return (
    <FormControl fullWidth disabled={validationErrors?.organization || isDisabled}>
      {label ? (
        <InputLabel id='invoice-option-label' error={isSelected ? validationErrors.invoiceOption : false}>
          Invoice Option
        </InputLabel>
      ) : null}

      <Select
        labelId='invoice-option-label'
        label={label ? 'Invoice Option' : ''}
        value={invoiceOption}
        onChange={onChange}
        required
        error={isSelected ? validationErrors.invoiceOption : false}
      >
        {/* <MenuItem value='' disabled>
          Select Business Type
        </MenuItem> */}
        <MenuItem value='Clone & Replace Existing Invoice' disabled={!isCloning}>
          Clone & Replace Existing Invoice
        </MenuItem>
        <MenuItem value='Merge with Existing Invoice' disabled sx={{ display: 'none' }}>
          Merge with Existing Invoice
        </MenuItem>
        <MenuItem value='New Invoice' disabled={isCloning}>
          New Invoice
        </MenuItem>
      </Select>
      {/* <FormHelperText>{validationErrors.type && 'Business type is required'}</FormHelperText> */}
    </FormControl>
  )
}

export default SelectInvoiceOption
